(ns ycweb.app.admin.storeplans.overview
  (:require
   [cemerick.url :as url]
   [rum.core :as rum]
   [util.string :as str]
   [ycweb.app.admin.storeplans.common :as sp.cmn]
   [util.transform :as trf]
   [ycweb.components.buttons :as buttons]
   [ycweb.components.common :as cmn]
   [ycweb.components.datatables.datatables :as datatables]
   [ycweb.components.editor.base :as editor]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as yuc]
   [ycweb.util.urlstate :as urlstate]))

(def store-order
  ["V&A Waterfront"
   "Sandton City"
   "Menlyn Park"
   "Constantia Village"
   "Gateway"
   "Willowbridge"
   "Somerset Mall"
   "Canal Walk"
   "Mall of Africa"
   "Morningside"
   "Brooklyn"
   "Gardens"
   "Ballito"
   "Northridge Mall"
   "Westlake"
   "Ilanga Mall"
   "Whale Coast"
   "Woodlands"
   "Cavendish"
   "Eastgate"])

(defn generated-store-plan-form-fields [selected-store-plan]
  (let [store-name (:store/name selected-store-plan)
        store-id (:store/id selected-store-plan)]
    [{:name [:store-plan/stores store-id :store-plan/mdq]
      :label (str store-name " MDQ: ")
      :type :number
      :attr {:type :number}}
     {:name [:store-plan/stores store-id :store-plan/in-store-stock-qty]
      :label (str store-name " Store In Stock Qty: ")
      :type :number
      :attr {:type :number}}
     {:name [:store-plan/stores store-id :store-plan/total-qty]
      :label (str store-name " Plan Total Qty: ")
      :type :number
      :attr {:type :number}}]))

(defn overview-editor-config [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        selected-ids (set (cmn/curact process-atom :store-plan/selected-ids))
        store-plans-idx (cmn/curact process-atom :store-plans)
        store-plan-form-fields
        (->>
          selected-ids
          (map #(get store-plans-idx %))
          (sort-by
            (fn [store]
              (let [sort-val
                    (or
                      (.indexOf store-order
                        (:store/name store))
                      (count store-order))]
                sort-val)))
          (reduce #(concat %1 (generated-store-plan-form-fields %2)) []))]
    {:editor-name :admin.store-plans/overview.editor
     :datatable :admin.store-plans/overview.datatable
     :mode :read
     :submit-all? true
     :eager-submit? true
     :end-points
     {:edit :admin.store-plans/override.store-plan-variation}
     :fields
     (concat
       [{:name :override/mdq
         :label "MDQ Quantity:"
         :type :number
         :attr {:type :number}}
        {:name :override/in-store-stock-qty
         :label "Override Store In Stock Qty:"
         :type :number
         :attr {:type :number}}
        {:name :override/total-qty
         :label "Override Store Plan Total Qty"
         :type :number
         :attr {:type :number}}
        ;;Stock Turn
        {:name :override/in-store-stock-turn
         :label "Override Store Stock Turn"
         :type :number
         :attr {:type :number}}
        {:name :override/store-plan-turn
         :label "Override Store Plan Turn"
         :type :number
         :attr {:type :number}}
        ;; Max clipping
        {:name :override/in-store-stock-max
         :label "Override Store Stock Max"
         :type :number
         :attr {:type :number}}
        {:name :override/store-plan-max
         :label "Override Store Plan Max"
         :type :number
         :attr {:type :number}}
        ;;Hidden fields
        {:name :store-plan/ids
         :type :hidden}
        {:name :variation/id
         :type :hidden}
        {:name :store-plan/days
         :type :hidden}]
       store-plan-form-fields)}))

(defn overview-table-fns [app-atom]
  {:column-fns
   {:product-link-fn
    (fn [app-atom row col cell-val]
      [:a
       {:href
        (str "/admin/pages_edit.htm?overrideincludes=popup&sm[e1][action]=contentedit&sm[e1][cntid]=" (:product/id row))
        :target "_blank"}
       cell-val])

    :freestock-link-fn
    (fn [app-atom row col cell-val]
      [:a
       {:href
        (str "/admin/freestock.htm?overrideincludes=popup&variationid=" (:variation/id row))
        :target "_blank"}
       cell-val])

    :log-link-fn
    (fn [app-atom row col cell-val]
      (map
        (fn [[_ store]]
          [[:a
            {:href
             (str "storeplans.htm?action=changelog&overrideincludes=popup&variation_id=" (:variation/id row) "&plan_id=" (:store-plan/id store))
             :target "_blank"}
            (:store-plan/store-name store)]
           [:br]])
        (:store-plan/stores row)))

    :override-value-display-fn
    (fn [_ row col cell-val]
      (let [col-key (:key col)
            field-key (last col-key)
            field-name (name field-key)
            col-path (butlast col-key)
            override-col-path
            (conj (vec col-path) (keyword (str "override/" field-name)))
            override-value (get-in row override-col-path)]
        (cond
          (yuc/presence override-value)
          override-value

          :else
          cell-val)))

    :supplier-logic
    (fn [app-atom _ _ cell-val]
      (get-in @(cmn/action-cursor app-atom) [:suppliers cell-val :companyname]))

    :cat-logic
    (fn [app-atom _ _ cell-val]
      (get-in @(cmn/action-cursor app-atom) [:categories cell-val :catfullname]))

    :brand-logic
    (fn [app-atom _ _ cell-val]
      (get-in @(cmn/action-cursor app-atom) [:brands cell-val :brandrootname]))

    :feedback-render-fn
    (fn [_ row _ _]
      (let [focuses [:mdq :in-store-stock-qty :total-qty]
            override-cells [:override/mdq :override/in-store-stock-qty :override/total-qty]

            stores (:store-plan/stores row)

            edited?
            (not
              (empty?
                (mapcat
                  #(vals (select-keys % override-cells))
                  (vals stores))))

            payloads
            (mapcat
              (fn [store]
                (map
                  (fn [focus]
                    [focus
                     (get store (keyword "override-type" focus))
                     (:store-plan/mdq store)
                     (:store-plan/total-qty store)
                     (:store-plan/in-store-stock-qty store)
                     (:override/mdq store)
                     (:override/total-qty store)
                     (:override/in-store-stock-qty store)])
                  focuses))
              (vals stores))

            feedback-set
            (set
              (map
                #(:feedback (apply sp.cmn/determine-feedback %))
                payloads))]
        (when edited?
          (apply str
            (interpose ","
              (remove nil?
                feedback-set))))))

    :override-qty-edit-fn
    (editor/edit-field
      :admin.store-plans/overview.editor :inline
      {:onblur-fn :submit})

    :override-store-qty-edit-fn
    (editor/edit-field
      :admin.store-plans/overview.editor :inline
      {:onblur-fn :submit
       :editor-fns
       {:input-hint-k
        (fn [_ row col _]
          (let [col-key (:key col)
                field-key (last col-key)
                field-name (name field-key)
                field-namespace (namespace field-key)
                col-path (butlast col-key)

                original-col-path
                (conj (vec col-path) (keyword (str field-namespace "/" field-name)))
                original-value (get-in row original-col-path)

                override-col-path
                (conj (vec col-path) (keyword (str "override/" field-name)))
                override-value (get-in row override-col-path)]

            (str "Original: " original-value
              (when
               override-value
                (str " | Override: " override-value)))))}})

    :mdq-value-difference-fn
    (fn [row col]
      (let [column-key (:key col)
            store-map (get-in row (butlast column-key))]

        (cond
          (or
            (:override/mdq store-map)
            (:override/total-qty store-map)
            (:override/in-store-stock-qty store-map))
          (:class
           (sp.cmn/determine-feedback
             :mdq
             (:override-type/mdq store-map)
             (:store-plan/mdq store-map)
             (:store-plan/total-qty store-map)
             (:store-plan/in-store-stock-qty store-map)
             (:override/mdq store-map)
             (:override/total-qty store-map)
             (:override/in-store-stock-qty store-map)))

          :else
          [:cell-group-colour])))

    :in-store-stock-difference-fn
    (fn [row col]
      (let [column-key (:key col)
            store-map (get-in row (butlast column-key))]

        (cond
          (or
            (:override/mdq store-map)
            (:override/total-qty store-map)
            (:override/in-store-stock-qty store-map))
          (:class
           (sp.cmn/determine-feedback
             :in-store-stock-qty
             (:override-type/in-store-stock-qty store-map)
             (:store-plan/mdq store-map)
             (:store-plan/total-qty store-map)
             (:store-plan/in-store-stock-qty store-map)
             (:override/mdq store-map)
             (:override/total-qty store-map)
             (:override/in-store-stock-qty store-map)))

          :else
          [:cell-group-colour])))

    :total-qty-value-difference-fn
    (fn [row col]
      (let [column-key (:key col)
            store-map (get-in row (butlast column-key))]
        (cond
          (or
            (:override/mdq store-map)
            (:override/total-qty store-map)
            (:override/in-store-stock-qty store-map))
          (:class
           (sp.cmn/determine-feedback
             :total-qty
             (:override-type/total-qty store-map)
             (:store-plan/mdq store-map)
             (:store-plan/total-qty store-map)
             (:store-plan/in-store-stock-qty store-map)
             (:override/mdq store-map)
             (:override/total-qty store-map)
             (:override/in-store-stock-qty store-map)))

          :else
          [:cell-group-colour])))

    :calculate-store-in-stock-turn-fn
    (fn [_ row _ store-cell-val]
      (let [in-store-stock-qty
            (or
              (:override/in-store-stock-qty store-cell-val)
              (:store-plan/in-store-stock-qty store-cell-val))]
        (sp.cmn/calculate-turn
          (:store/sales store-cell-val)
          in-store-stock-qty
          (:store-plan/days row))))

    :calculate-store-total-qty-turn-fn
    (fn [_ row _ store-cell-val]
      (let [total-qty
            (or
              (:override/total-qty store-cell-val)
              (:store-plan/total-qty store-cell-val))]
        (sp.cmn/calculate-turn
          (:store/sales store-cell-val)
          total-qty
          (:store-plan/days row))))

    :calculate-planned-total-turn-fn
    (fn [_ row col call-val-qty]
      (let [store-ids (:store-plan/ids row)
            store-idx (:store-plan/stores row)
            total-turn
            (reduce
              (fn [acc [store-id store]]
                (let [total-qty
                      (or
                        (:override/total-qty store)
                        (:store-plan/total-qty store))
                      turn
                      (sp.cmn/calculate-turn
                        (:store/sales store)
                        total-qty
                        (:store-plan/days row))]
                  (+ acc turn)))
              0 store-idx)]
        (yuc/round (/ total-turn (count store-ids)))))

    :calculate-in-store-turn-fn
    (fn [_ row col cell-val-qty]
      (let [store-ids (:store-plan/ids row)
            store-idx (:store-plan/stores row)
            total-turn
            (reduce
              (fn [acc [store-id store]]
                (let [in-store-stock-qty
                      (or
                        (:override/in-store-stock-qty store)
                        (:store-plan/in-store-stock-qty store))
                      turn
                      (sp.cmn/calculate-turn
                        (:store/sales store)
                        in-store-stock-qty
                        (:store-plan/days row))]
                  (+ acc turn)))
              0 store-idx)]
        (yuc/round (/ total-turn (count store-ids)))))

    :calculate-actual-in-store-turn-fn
    (fn [_ row col cell-val-qty]
      (sp.cmn/calculate-turn
        (:store/sales row)
        (:store-plan/in-store-stock-qty row)
        (:store-plan/days row)))}})

(defn generated-store-plan-columns [selected-store-plan]
  (let [store-name (:store/name selected-store-plan)
        store-id (:store/id selected-store-plan)
        col-classes (yuc/bem :cell-status [:is-editable])]
    [{:key [:store-plan/stores store-id :store-plan/mdq]
      :title "MDQ"
      :group store-name
      :render {:logic-k :override-value-display-fn}
      :align-class :u-text-center
      :cell-classes-k :mdq-value-difference-fn
      :col-classes col-classes
      :cell-edit :override-store-qty-edit-fn}
     {:key [:store-plan/stores store-id :store-plan/in-store-stock-qty]
      :title "In-Stock Qty"
      :group store-name
      :render {:logic-k :override-value-display-fn}
      :align-class :u-text-center
      :cell-classes-k :in-store-stock-difference-fn
      :col-classes col-classes
      :cell-edit :override-store-qty-edit-fn}
     {:key [:store-plan/stores store-id :store-plan/total-qty]
      :title "Plan Total Qty"
      :group store-name
      :render {:logic-k :override-value-display-fn}
      :align-class :u-text-center
      :cell-classes-k :total-qty-value-difference-fn
      :col-classes col-classes
      :cell-edit :override-store-qty-edit-fn}
     {:key [:store-plan/stores store-id]
      :title "In-Stock Turn"
      :group store-name
      :align-class :u-text-center
      :render {:logic-k :calculate-store-in-stock-turn-fn}}
     {:key [:store-plan/stores store-id]
      :title "Plan Total Turn"
      :group store-name
      :align-class :u-text-center
      :render {:logic-k :calculate-store-total-qty-turn-fn}}]))

(defn overview-column-defs [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        days (or (cmn/curact action-atom [:filters :days]) 14)
        selected-ids (set (cmn/curact process-atom :store-plan/selected-ids))
        store-plans-idx (cmn/curact process-atom :store-plans)

        store-plan-columns
        (->>
          selected-ids
          (map #(get store-plans-idx %))
          (sort-by
            (fn [store]
              (let [sort-val
                    (or
                      (.indexOf store-order
                        (:store/name store))
                      (count store-order))]
                sort-val)))
          (reduce #(concat %1 (generated-store-plan-columns %2)) []))

        col-classes
        (concat
          [:cell-group-colour]
          (yuc/bem :cell-status [:is-editable]))]

    (concat
      [{:key :variation/id
        :title "Variation ID"
        :align-class :u-text-center}
       {:key :supplier/id
        :title "Supplier"
        :render {:logic-k :supplier-logic}}
       {:key :brand/root-id
        :title "Brand"
        :render {:logic-k :brand-logic}}
       {:key :product/name
        :title "Product"
        :align-class :u-text-left
        :render {:render-k :product-link-fn}}
       {:key :variation/code
        :title "Code"}
       {:key :variation/features
        :title "Features"}
       {:key :variation/end-use
        :title "End Use"}
       {:key :category/id
        :title "Category"
        :render {:logic-k :cat-logic}}
       {:key :product/status
        :title "Product Live"
        :align-class :u-text-center}
       {:key :supplier/availability
        :title "Supplier Available"
        :align-class :u-text-center}
       {:key :supplier/estimated-arrival-time
        :title "Supplier ETA"
        :align-class :u-text-center
        :type :date
        :dateformat "Y-M-d"
        :default ""}
       {:key :store-plan/stores-ranged-count
        :title "Stores Ranged"
        :type :number}
       {:key :store-plan/mdq
        :title "Avg Min Qty for Display"
        :type :number}
       {:key :store-plan/in-store-stock-qty
        :title "Sum Store Instock Qty (NEW)"
        :type :number}
       {:key :store-plan/total-qty
        :title "Sum Store Plan Total Qty"
        :type :number}
       {:key :store-plan/display-qty
        :title "Sum Plan Total Qty - MDQ"
        :type :number
        :align-class :u-text-right}
       {:key :variation/cost-price
        :title "Avg Cost Price"
        :type :currency
        :align-class :u-text-right}
       {:key :store-plan/in-store-stock-qty-value
        :title "Sum Store Instock Value"
        :type :currency
        :align-class :u-text-right}
       {:key :store-plan/total-qty-value
        :title "Sum Store Plan Total Value"
        :type :currency
        :align-class :u-text-right}
       {:key :stock/on-hand
        :title "Sum Store SOH"
        :type :number}
       {:key :stock/transit-ibt
        :title "Sum Transit IBTs"
        :type :number}
       {:key :stock/store-ibt
        :title "Sum Pending IBTs"
        :type :number}
       {:key :store/on-hand-history-avg
        :title (str "Sum Store Avg SOH (" days " Days)")
        :type :number
        :decimals 1}
       {:key :variation/free-stock
        :title "HQ Free Stock"
        :align-class :u-text-right
        :render {:render-k :freestock-link-fn}}
       {:key :variation/ringfenced-qty
        :title "HQ Ringfenced Qty"
        :align-class :u-text-right}
       {:key :variation/on-order
        :title "HQ Stock On Order"
        :type :number}
       {:key :variation/future-order
        :title "HQ Stock On Future Order"
        :type :number}
       {:key :variation/supplier-on-hand
        :title "Supplier SOH"
        :type :number}
       {:key :variation/non-picking-stock
        :title "Sum Non Picking Stock"
        :type :number}
       {:key :store/sales
        :title (str "Sum Store Sales (" days " Days)")
        :type :number}
       {:key :stock/qty-on-hand
        :title "Sum Plan - (SOH + IBT)"
        :type :number}
       {:key :store/stock-turn
        :title "Avg Annual Turn (From Plan)"
        :type :number
        :decimals 1}
       {:key :store/stock-turn-avg
        :title "Avg Annual Turn (From Avg On Hand)"
        :type :number
        :decimals 1}
       {:key :stock/needed-at-hq
        :title "Needed at HQ"
        :type :number}
       {:key :variation/id
        :title "Log"
        :render {:render-k :log-link-fn}}]
      store-plan-columns
      [{:key :override/mdq
        :title "MDQ"
        :group "Override"
        :type :number
        :cell-edit :override-qty-edit-fn
        :align-class :u-text-center
        :col-classes col-classes}
       {:key :override/in-store-stock-qty
        :title "In-Stock Qty"
        :group "Override"
        :type :number
        :cell-edit :override-qty-edit-fn
        :align-class :u-text-center
        :col-classes col-classes}
       {:key :override/total-qty
        :title "Total Qty"
        :group "Override"
        :type :number
        :cell-edit :override-qty-edit-fn
        :align-class :u-text-center
        :col-classes col-classes}
       {:key :override/in-store-stock-turn
        :title "Store In-Stock Turn"
        :group "Override"
        :type :number
        :decimals 1
        :align-class :u-text-center
        :col-classes col-classes
        :cell-edit :override-qty-edit-fn}
       {:key :override/store-plan-turn
        :title "Store Plan Turn"
        :group "Override"
        :type :number
        :decimals 1
        :align-class :u-text-center
        :col-classes col-classes
        :cell-edit :override-qty-edit-fn}
       {:key :override/in-store-stock-max
        :title "In Store Stock Max"
        :group "Override"
        :type :number
        :align-class :u-text-center
        :col-classes col-classes
        :cell-edit :override-qty-edit-fn}
       {:key :override/store-plan-max
        :title "Store Plan Max"
        :group "Override"
        :type :number
        :align-class :u-text-center
        :col-classes col-classes
        :cell-edit :override-qty-edit-fn}
       {:key :override/feedback
        :title "Feedback"
        :group "Override"
        :align-class :u-text-center
        :render {:logic-k :feedback-render-fn}}
       {:key :store/in-store-stock-turn-avg
        :title "Planned In Stock Turn"
        :group "Average"
        :type :number
        :align-class :u-text-center
        :render {:logic-k :calculate-in-store-turn-fn}}
       {:key :store/total-qty-stock-turn-avg
        :title "Planned Store Plan Total Turn"
        :group "Average"
        :type :number
        :align-class :u-text-center
        :render {:logic-k :calculate-planned-total-turn-fn}}
       {:key :store/stock-turn-avg
        :title "Actual In Stock Qty Turn"
        :group "Average"
        :type :number
        :align-class :u-text-center
        :render {:logic-k :calculate-actual-in-store-turn-fn}}])))

(defn overview-grid-columns [app-atom]
  (let [action-name (cmn/process-action-name app-atom)]
    {:table-name :admin.store-plans/overview.datatable
     :row-id :variation/id
     :data-source
     {:cursor [action-name :store-plans/overview]}
     :options
     {:order :asc
      :sort-title "Product"
      :paging? true
      :sticky-header? true
      :pagination {:page 0 :page-size 150}}
     :column-defs (overview-column-defs app-atom)}))

(defmethod comms/receive :admin.store-plans/override.store-plan-variation
  [app-atom submission-response]
  (let [status (editor/post-submit app-atom :admin.store-plans/overview.editor submission-response)
        {:keys [row-id table-name]} (overview-grid-columns app-atom)
        table-atom (datatables/table-cursor app-atom table-name)
        table-cfg (:config @table-atom)
        data-src (:data-source table-cfg)]
    (when (:success status)
      (sp.cmn/update-overview-rows
        app-atom
        (:cursor data-src)
        (:rows submission-response)
        row-id))))

(rum/defc store-plan-config < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        plan-config-atom (rum/cursor-in action-atom [:plan-config])
        in-stock-qty (cmn/curact plan-config-atom :global/in-stock-qty)
        total-qty (cmn/curact plan-config-atom :global/total-qty)
        in-stock-qty-turn (cmn/curact plan-config-atom :global/in-stock-qty-turn)
        total-qty-turn (cmn/curact plan-config-atom :global/total-qty-turn)]
    [:div.u-margin-bottom-30
     [:h3 {:class (yuc/bem :yc-heading [:default :flush])} "Plan config:"]
     [:div.u-margin-top-16.u-bg-ghost
      {:class (yuc/bem :card [:no-hover] :text-card [:small])}
      [:div
       {:class (yuc/bem :flex-grid-group [:valign-bottom :align-left :flush])}
       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Set all MDQs:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/mdq)
           {})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Set all store in-stock qtys:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/in-stock-qty)
           {:disabled (and (yuc/presence in-stock-qty-turn) (not (zero? in-stock-qty-turn)))})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Set all store plan total qtys:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/total-qty)
           {:disabled (and (yuc/presence total-qty-turn) (not (zero? total-qty-turn)))})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Desired in-stock qty turn:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/in-stock-qty-turn)
           {:disabled (and (yuc/presence in-stock-qty) (not (zero? in-stock-qty)))})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Desired plan total qty turn:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/total-qty-turn)
           {:disabled (and (yuc/presence total-qty) (not (zero? total-qty)))})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Desired in-stock qty Max:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/in-stock-qty-max)
           {:disabled (and (yuc/presence in-stock-qty) (not (zero? in-stock-qty)))})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:label.form-label "Desired plan total qty Max:"]
         (forms/input-raw ""
           (rum/cursor plan-config-atom :global/total-qty-max)
           {:disabled (and (yuc/presence total-qty) (not (zero? total-qty)))})]]

       [:div
        {:class (yuc/bem :flex-grid-block [:l-1-8 :ml-1-4 :t-1-2 :fluid])}
        [:div.flex-grid-content
         [:div.flex-grid-content
          (buttons/button "Apply config"
            #(grid/dispatch-action app-atom :admin.store-plans/apply-config {})
            {:primary true
             :bordered true
             :raised true
             :full true})]]]]
      [:div
       {:class (yuc/bem :flex-grid-group [:valign-bottom :align-left :flush])}
       [:div
        {:class (yuc/bem :flex-grid-block [:fluid])}
        [:div.flex-grid-content
         (forms/checkbox "Limit to MDQ" (rum/cursor plan-config-atom :global/mdq-limit))]]]]]))

(defn multiselect-cell [app-atom row v]
  [:div
   {:style {:padding "8px 6px"}
    :class (yuc/bem :flex-grid-group [:align-left :valign-middle])}
   [:div
    {:style {:margin-right "4px"}
     :class (yuc/bem :flex-grid-block [:fluid :flush])}]
   [:div
    {:class (yuc/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (:ent/display-name v)]]])

(defn multiselect-cell-selected [app-atom action-config row v]
  [:span
   {:class (yuc/bem :text-pill [:medium :light])
    :style
    {:margin-right "4px"
     :background-color "#eeeeee"}}
   (multiselect-cell app-atom row v)])

(defn multiselect-cell-toggle [app-atom list-atom {:keys [item-selector selected-key]} v]
  [:div
   {:style {:padding "8px 4px"}
    :class (yuc/bem :flex-grid-group [:flush :align-left :valign-middle])}
   [:div
    {:class (yuc/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (forms/toggle "" (rum/cursor-in list-atom [(get v item-selector) selected-key])
       {:on-change identity})]]
   [:div
    {:class (yuc/bem :flex-grid-block [:fluid :flush])}
    [:div.flex-grid-content
     (multiselect-cell app-atom {} v)]]])

(defn prepare-store-options [stores stores-idx]
  (let [is-selected? #(get-in stores-idx [(:store-plan/id %) :store-plan/selected?])
        all-selected? (and (seq stores) (every? is-selected? stores))
        toggle-item
        {:store-plan/id :all-stores-toggle
         :ent/display-name "All Stores"
         :store-plan/selected? all-selected?}

        sorted-stores (sort-by :ent/display-name stores)]

    {:options (cons toggle-item sorted-stores)
     :all-selected? all-selected?}))

(defn handle-store-select [app-atom filters-atom stores item all-selected?]
  (if (= (:store-plan/id item) :all-stores-toggle)
    (grid/dispatch-action app-atom :admin.store-plans/multi-select-toggle-all
      {:entity-atom filters-atom
       :filter-selector :stores-idx
       :item-selector :store-plan/id
       :selected-key :store-plan/selected?
       :target-val (not all-selected?)
       :all-items stores})
    (grid/dispatch-action app-atom :admin.store-plans/multi-select-update
      {:entity-atom filters-atom
       :filter-selector :stores-idx
       :item-selector :store-plan/id
       :selected-key :store-plan/selected?
       :selected-item item})))

(rum/defc store-plan-filters < rum/reactive [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        filters-atom (rum/cursor-in action-atom [:filters])
        category-search-atom (rum/cursor action-atom :search-categories)
        stores-idx (:stores-idx (rum/react filters-atom))
        stores (vals stores-idx)
        {:keys [options all-selected?]} (prepare-store-options stores stores-idx)
        brands (vals (:brands-idx (rum/react filters-atom)))
        category (cmn/curact filters-atom :category)

        display-name-filter-pred
        #(str/includes?
           (str/lower-case (:ent/display-name %1))
           (str/lower-case %2))]

    [[:div.u-margin-bottom-30
      (headings/heading (str "Filters:") {:type :h3 :size :medium :flush true})
      [:div.u-margin-top-16.u-bg-ghost
       {:class (yuc/bem :card [:no-hover] :text-card [:small])}
       [:div
        {:class (yuc/bem :flex-grid-group [:valign-bottom :align-left :flush])}
        [:div
         {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-1-2 :fluid])}
         [:div.flex-grid-content
          [:label.form-label "Stores:"]
          (forms/inline-autocomplete-select
            (into
              [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}]
              (->>
                options
                (filter
                  #(and
                     (:store-plan/selected? %)
                     (not= (:store-plan/id %) :all-stores-toggle)))
                (map #(multiselect-cell-selected app-atom {} {} %))))
            options
            {:select-style? true
             :force-open? true
             :close-on-select? false
             :match-count (count options)
             :select-fn (fn [item & _] (handle-store-select app-atom filters-atom stores item all-selected?))
             :item-render-fn
             (fn [item & _]
               (if (= (:store-plan/id item) :all-stores-toggle)
                 [:div
                  {:style {:padding "8px 4px"}
                   :class (yuc/bem :flex-grid-group [:align-left :valign-middle])}
                  (forms/toggle
                    ""
                    (atom (:store-plan/selected? item))
                    {:on-change identity})

                  [:div
                   {:class (yuc/bem :flex-grid-block [:fluid :flush])}
                   [:div.flex-grid-content "All Stores"]]]

                 (multiselect-cell-toggle app-atom
                   (rum/cursor filters-atom :stores-idx)
                   {:item-selector :store-plan/id
                    :selected-key :store-plan/selected?}
                   item)))

             :filter-fn
             (fn [text item & _]
               (or (= (:store-plan/id item) :all-stores-toggle)
                 (display-name-filter-pred text item)))})]]

        [:div
         {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-1-2 :fluid])}
         [:div.flex-grid-content
          [:label.form-label "Categories:"]
          (forms/inline-autocomplete-field
            [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}
             (when category
               (multiselect-cell-selected app-atom {} {} category))]
            (rum/cursor-in category-search-atom [:search :results])
            {:select-style? true
             :empty-list-hint "No categories found"
             :min-count 2
             :item-render-fn (fn [item] (:ent/display-name item))
             :change-fn
             #(grid/dispatch-action app-atom
                :admin.store-plans/category-search
                {:search %})
             :select-fn #(swap! filters-atom assoc :category %)
             :deselect-fn #(swap! filters-atom dissoc :category %)})]]
        [:div
         {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-1-2 :fluid])}
         [:div.flex-grid-content
          [:label.form-label "Brands:"]
          (forms/inline-autocomplete-select
            (into
              [:div {:style {:padding-top "8px" :overflow "hidden" :white-space "nowrap"}}]
              (->>
                brands
                (filter #(:brand/selected? %))
                (map #(multiselect-cell-selected app-atom {} {} %))))
            (sort-by (juxt (comp not :brand/selected?) :ent/display-name) brands)
            {:select-style? true
             :force-open? true
             :select-fn
             #(grid/dispatch-action app-atom :admin.store-plans/multi-select-update
                {:entity-atom filters-atom
                 :filter-selector :brands-idx
                 :item-selector :brand/id
                 :selected-key :brand/selected?
                 :selected-item %})
             :item-render-fn
             (partial multiselect-cell-toggle app-atom (rum/cursor filters-atom :brands-idx)
               {:item-selector :brand/id
                :selected-key :brand/selected?})
             :filter-fn display-name-filter-pred})]]
        [:div
         {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-1-2 :fluid])}
         [:div.flex-grid-content
          [:label.form-label "Days:"]
          (forms/input-raw ""
            (rum/cursor filters-atom :days)
            {})]]

        [:div
         {:class (yuc/bem :flex-grid-block [:ml-1-5 :t-full :fluid])}
         [:div.flex-grid-content
          (buttons/button "Filter"
            #(grid/dispatch-action app-atom :admin.store-plans/apply-filters
               {})
            {:primary true
             :bordered true
             :raised true
             :full true})]]]]]]))

(defmethod grid/action :admin.store-plans/multi-select-toggle-all
  [app-atom {:keys [entity-atom filter-selector item-selector selected-key target-val all-items]} _]
  (swap! entity-atom update filter-selector
    (fn [current-options]
      (let [existing-selection (or current-options {})
            key-fn (or selected-key :selected?)]
        (reduce
          (fn [acc item]
            (let [id (get item item-selector)
                  base-item (get existing-selection id item)]
              (assoc acc id (assoc base-item key-fn target-val))))
          existing-selection
          all-items)))))

(defmethod grid/action :admin.store-plans/multi-select-update
  [app-atom {:keys [entity-atom filter-selector item-selector selected-key selected-item]}]
  (swap! entity-atom update filter-selector
    (fn [current-options]
      (let [existing-option (get current-options (get selected-item item-selector))
            selected?
            (not
              (if existing-option
                (get existing-option (or selected-key :selected?))
                (get selected-item (or selected-key :selected?))))]

        (assoc-in current-options
          [(get selected-item item-selector)]
          (assoc selected-item (or selected-key :selected?) selected?))))))

(defn calculate-overview-params [app-atom]
  (let [action-atom (cmn/action-cursor app-atom)
        {:keys [stores-idx brands-idx days category]} (cmn/curact action-atom :filters)

        store-plan-ids
        (->>
          (vals stores-idx)
          (filter :store-plan/selected?)
          (map :store-plan/id)
          (str/join ","))

        brand-ids
        (->>
          (vals brands-idx)
          (filter :brand/selected?)
          (map :brand/id)
          (str/join ","))]

    (yuc/maybe assoc
      {:ids store-plan-ids}
      :days (yuc/presence days)
      :catid (:category/id category)
      :brandids (yuc/presence brand-ids))))

(defmethod grid/action :admin.store-plans/apply-filters [app-atom {:keys [filter-type]} _]
  (let [url-params (calculate-overview-params app-atom)]

    (if (not (yuc/presence (:ids url-params)))
      (toaster/open-toast app-atom :error "No Stores selected to filter" {})
      (urlstate/redirect app-atom "storeplans" "overview" url-params))))

(def batched-number 500)

(defmethod grid/action :admin.store-plans/apply-config [app-atom config _]
  (let [process-atom (cmn/process-cursor app-atom)
        action-atom (cmn/action-cursor app-atom)
        plan-config (cmn/curact action-atom [:plan-config])
        filters-atom (rum/cursor-in action-atom [:filters])
        days (cmn/curact filters-atom :days)
        selected-store-plan-ids (cmn/curact process-atom :store-plan/selected-ids)
        table-rows-idx
        (datatables/filtered-rows app-atom
          :admin.store-plans/overview.datatable
          (overview-table-fns app-atom))
        vids (keys table-rows-idx)
        batched-vids (vec (partition-all batched-number vids))
        first-batch (get batched-vids 0)]

    (toaster/open-overlay app-atom :admin.store-plans/overview-loading-overlay
      (str "Applying config to " (count vids) " variations"))
    #?(:cljs (.scrollTo js/window 0 0))
    (swap! action-atom assoc :global-config
      {:global/counter 0
       :variation/batched-ids batched-vids
       :plan-config
       (assoc plan-config
         :store-plan/days days
         :store-plan/ids selected-store-plan-ids)})
    (comms/send :admin.store-plans/global-override.store-plan-variation
      (assoc plan-config
        :store-plan/days days
        :variation/ids first-batch
        :variations (select-keys table-rows-idx first-batch)
        :store-plan/ids selected-store-plan-ids))))

(defmethod comms/receive :admin.store-plans/global-override.store-plan-variation
  [app-atom submission-response]
  (toaster/close-overlay app-atom :admin.store-plans/overview-loading-overlay)
  (let [action-atom (cmn/action-cursor app-atom)
        status (editor/post-submit app-atom :admin.store-plans/overview.editor submission-response)
        {:keys [row-id table-name]} (overview-grid-columns app-atom)
        table-atom (datatables/table-cursor app-atom table-name)
        table-cfg (:config @table-atom)
        data-src (:data-source table-cfg)
        global-config (cmn/curact action-atom :global-config)
        global-counter (inc (:global/counter global-config))
        rows-idx (datatables/rows app-atom :admin.store-plans/overview.datatable)
        total-number (count (:variation/batched-ids global-config))
        next-batch (get (:variation/batched-ids global-config) global-counter)]
    (when (:success status)
      (sp.cmn/update-overview-rows
        app-atom
        (:cursor data-src)
        (:rows submission-response)
        row-id)
      (swap! action-atom assoc-in [:global-config :global/counter] global-counter)
      (cond
        (< global-counter total-number)
        (do
          (toaster/open-overlay app-atom :admin.store-plans/overview-loading-overlay
            (str "Applying config: " (* global-counter batched-number) " / " (* total-number batched-number) " variations processed"))
          (comms/send :admin.store-plans/global-override.store-plan-variation
            (assoc
              (:plan-config global-config)
              :variation/ids next-batch
              :variations (select-keys rows-idx next-batch))))

        (= global-counter total-number)
        (swap! action-atom dissoc :global-config)))))

(defmethod grid/action :admin.store-plans/category-search [app-atom {:keys [search]} _]
  (let [action-atom (cmn/action-cursor app-atom)
        search-atom (rum/cursor-in action-atom [:search-categories :search])]
    (swap! search-atom assoc :input search)
    (comms/send :admin.store-plans/search-categories {:search search})))

(defmethod comms/receive :admin.store-plans/search-categories [app-atom {:keys [term categories]}]
  (let [action-atom (cmn/action-cursor app-atom)
        category-search-atom (rum/cursor action-atom :search-categories)]
    (when (= term (get-in @category-search-atom [:search :input]))
      (swap! category-search-atom assoc-in [:search :results] categories))))

(rum/defcs suggested-filters-list < rum/reactive (rum/local {} ::state) [s app-atom config]
  (let [local-atom (::state s)
        selected-atom (rum/cursor local-atom :selected-item)
        action-atom (cmn/action-cursor app-atom)
        days (if (pos? (cmn/curact action-atom :days)) (cmn/curact action-atom :days) 14)]
    (list
      [:b "Weekly"]
      [:ul
       {:class (yuc/bem :yc-list [:small])}
       (sp.cmn/suggested-filter-item app-atom selected-atom "Slow Stock Turn" "(Reduce Plan Qty)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Avg Min Qty for Display" :order :asc}
          :filter-on
          {"Avg Min Qty for Display" ">0"
           "Sum Store Plan Total Qty" ">0"
           "Sum Plan Total Qty - MDQ" ">0"
           (str "Sum Store Avg SOH (" days " Days)") ">1.9"
           (str "Sum Store Sales (" days " Days)") ">=0"
           "Avg Annual Turn (From Plan)" "<6.1"
           "Avg Annual Turn (From Avg On Hand)" "<6.1"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Slow Stock Turn" "(Reduce Plan Qty)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Avg Min Qty for Display" :order :asc}
          :filter-on
          {"Avg Min Qty for Display" ">0"
           "Sum Store Plan Total Qty" ">0"
           "Sum Plan Total Qty - MDQ" ">0"
           (str "Sum Store Avg SOH (" days " Days)") ">1.9"
           (str "Sum Store Sales (" days " Days)") ">=0"
           "Avg Annual Turn (From Plan)" "<6.1"
           "Avg Annual Turn (From Avg On Hand)" "<6.1"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Fast Movers" "(Increase Plan Qty)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title  (str "Sum Store Sales (" days " Days)") :order :asc}
          :filter-on
          {"Avg Min Qty for Display" ">0"
           "Sum Store Plan Total Qty" ">0"
           "Avg Annual Turn (From Plan)" ">8"
           "Avg Annual Turn (From Avg On Hand)" ">8"}})]

      [:ul
       {:class (yuc/bem :yc-list [:small])}
       (sp.cmn/suggested-filter-item app-atom selected-atom "Has Sold in Store, Not in Plan" "(Add to Plan?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Supplier SOH" :order :asc}
          :filter-on
          {"Product Live" "Live"
           "Sum Store Plan Total Qty" "<=0"
           "Sum Non Picking Stock" ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Have SOH, Not in Plan" "(Add to Plan?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Sum Store Plan Total Value" :order :asc}
          :filter-on
          {"Product Live" "Live"
           "Sum Store Plan Total Qty" "<=0"
           "Sum Store SOH" ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "No AVG SOH, In Plan" "(Remove from Plan/Alert Store?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Avg Min Qty for Display" :order :asc}
          :filter-on
          {"Sum Store Plan Total Qty" ">0"
           (str "Sum Store Avg SOH (" days " Days)") "<=0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Need more in Store, Supplier Out" "(Remove from Plan/Alert Store?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Sum Non Picking Stock" :order :asc}
          :filter-on
          {"Supplier Available" "!Yes"
           "Sum Store Plan Total Qty" ">0"
           "HQ Free Stock" "<=0"
           "HQ Stock On Future Order" "<=0"
           (str "Sum Store Sales (" days " Days)") ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "More SOH than in Plan" "(Reverse IBT?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Sum Non Picking Stock" :order :desc}
          :filter-on
          {(str "Sum Store Sales (" days " Days)") "<0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Not Live on Site, in Plan" "(Remove/Reduce from Plan?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Avg Min Qty for Display" :order :asc}
          :filter-on
          {"Product Live" "!Live"
           "Sum Store Plan Total Qty" ">0"}})

       (sp.cmn/suggested-filter-item app-atom selected-atom "Needed at HQ - Paid Orders" " (Reduce Plan and Reverse IBT?)"
         {:datatable-key :admin.store-plans/overview.datatable
          :sort-on
          {:column-title "Sum Store Sales (" days " Days)" :order :desc}
          :filter-on
          {"Supplier Available" "!Yes"
           "Sum Store SOH" ">0"
           "HQ Stock On Future Order" "<=0"
           "Supplier SOH" "<500"
           "Avg Annual Turn (From Avg On Hand)" ">0"}})])))

(rum/defc modal-suggested-filters-body < rum/reactive [app-atom]
  [(headings/heading "Suggested Filters"
     {:type :h2 :size :default})
   (suggested-filters-list app-atom {})])

(rum/defc modal-suggested-filters-footer [app-atom config-atom]
  [[:div
    {:class (yuc/bem :flex-grid-group [:flush])}
    [:div
     {:class (yuc/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
     (buttons/button-web "Reset filters"
       {:type :button
        :on-click
        #(grid/dispatch-action app-atom :store-plan/apply-filter
           {:datatable-key :admin.store-plans/overview.datatable
            :sort-on
            {:column-title "Product" :order :asc}
            :filter-on {}})
        :style :primary
        :size :large
        :full true
        :persistent true
        :flat-style :flat})]

    [:div
     {:class (yuc/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
     (buttons/button-web "Close"
       {:type :button
        :on-click #(grid/close-modal app-atom)
        :style :secondary-noborder
        :size :large
        :full true
        :persistent true
        :flat-style :flat})]]])

(defmethod grid/modal-config :admin.store-plans/suggested-filters-modal [app-atom config _]
  {:body modal-suggested-filters-body
   :footer modal-suggested-filters-footer
   :modal-type :variable})

(rum/defc store-plan-header < rum/reactive [app-atom]
  [:div.u-margin-bottom-24
   [:div
    {:class
     (yuc/bem :flex-grid-group [:valign-middle :align-left :flush-force])}
    [:div
     {:class (yuc/bem :flex-grid-block [:grow-1 :fluid])}
     [:div.flex-grid-content
      [:h1
       {:class (yuc/bem :yc-heading [:large :flush])}
       "Stores Plan Management"]]]
    #_[:div
       {:class (yuc/bem :flex-grid-block [:fluid])}
       [:div.flex-grid-content
        (buttons/button "Summary Stats"
          #(println "Summary Stats")
          {:primary true
           :bordered true
           :raised true
           :full true})]]
    [:div
     {:class (yuc/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      (buttons/button "Suggested Table Filters"
        #(grid/open-modal app-atom :admin.store-plans/suggested-filters-modal)
        {:primary true
         :bordered true
         :raised true
         :full true})]]
    [:div
     {:class (yuc/bem :flex-grid-block [:fluid])}
     [:div.flex-grid-content
      (buttons/button-web "Back to Store Plans"
        (merge
          (urlstate/href-props app-atom "storeplans")
          {:style :secondary
           :size :default
           :icon :arrow-left}))]]]])

(rum/defc legend []
  (headings/heading "Status Legend:" {:type :h3 :size :small})
  [:ul.status-legend-list
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:info :m])}]]
    [:span.status-legend-list-item__text
     "Field Changed"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:warning :m])}]]
    [:span.status-legend-list-item__text
     "Field has a warning"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:error :m])}]]
    [:span.status-legend-list-item__text
     "Field has an error"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:green :m])}]]
    [:span.status-legend-list-item__text
     "Newly Ranged"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:dark-grey :m])}]]
    [:span.status-legend-list-item__text
     "De-ranged"]]
   [:li.status-legend-list-item.u-margin-bottom-10
    [:div.status-legend-list-item__color-dot
     [:span
      {:class (yuc/bem :admin-status-dot [:purple :m])}]]
    [:span.status-legend-list-item__text
     "Skipped"]]])

(rum/defc store-plans < rum/reactive [app-atom]
  [:div
   (store-plan-header app-atom)
   (store-plan-filters app-atom)
   (store-plan-config app-atom)
   (legend)
   (datatables/table app-atom :admin.store-plans/overview.datatable (overview-table-fns app-atom))
   [:div.admin-float-button-wrapper
    (buttons/button-web "Apply changes"
      {:style :primary
       :size :default
       :floating true
       :class "admin-float-button"
       :icon :thumbs-up
       :on-click #(grid/open-modal app-atom :admin.store-plans/save-modal)})]

   (toaster/loading-overlay app-atom :admin.store-plans/overview-loading-overlay)])

(defmethod flow/render-screen :admin.storeplans/overview [app-atom _]
  (store-plans app-atom))

(defn setup-overview-data [app-atom {:keys [ids days brandids catid]}]
  (let [process-atom (cmn/process-cursor app-atom)
        decoded-ids (url/url-decode ids)
        brand-decode-ids (url/url-decode brandids)

        store-plan-ids
        (->>
          (str/split decoded-ids #",")
          (map trf/tonumber))

        param-brandids
        (->>
          (str/split brand-decode-ids #",")
          (map trf/tonumber))

        all-store-plans (cmn/curact process-atom :store-plans)]

    (swap! process-atom assoc
      :store-plan/selected-ids store-plan-ids
      :store-plan/selected-brand param-brandids)

    (cond
      (empty? all-store-plans)
      (do
        (comms/send :admin.store-plans/list {})
        (comms/send :admin.store-plans/overview-summary
          (yuc/maybe assoc {:store-plan-ids store-plan-ids}
            :days days
            :brandids param-brandids
            :catid catid)))

      :else
      (comms/send :admin.store-plans/overview-summary
        (yuc/maybe assoc {:store-plan-ids store-plan-ids}
          :days days
          :brandids param-brandids
          :catid catid)))))

(defmethod t/transition-open :admin.storeplans/overview [app-atom _ {:keys [ids days brandids catid] :as params}]
  (toaster/open-overlay app-atom :admin.store-plans/overview-loading-overlay
    {:text (str "Transitioning to Store Plan Overview")})
  (setup-overview-data app-atom params))

(defmethod t/transition-after-open :admin.storeplans/overview [app-atom _ _]
  (datatables/initiate app-atom
    (overview-grid-columns app-atom) (overview-table-fns app-atom))
  (editor/initiate app-atom (overview-editor-config app-atom)))

(defmethod comms/receive :admin.store-plans/overview-summary
  [app-atom {:keys [rows filters suppliers categories brands]}]

  (toaster/close-overlay app-atom :admin.store-plans/overview-loading-overlay)
  (let [action-atom (cmn/action-cursor app-atom)
        process-atom (cmn/process-cursor app-atom)
        store-plan-ids (set (cmn/curact process-atom :store-plan/selected-ids))
        brandids (set (cmn/curact process-atom :store-plan/selected-brand))

        item-rows
        (->>
          rows
          (group-by :variation/id)
          (reduce
            (fn [acc [_ rows]]
              (let [row (first rows)
                    store-count (count store-plan-ids)
                    variation-cost-price (sp.cmn/row-average :variation/cost-price store-count rows)
                    in-store-stock-qty (sp.cmn/sum-rows :store-plan/in-store-stock-qty rows)
                    store-plan-total-qty (sp.cmn/sum-rows :store-plan/total-qty rows)

                    in-store-stock-qty-value
                    (sp.cmn/multiply-fields
                      variation-cost-price
                      in-store-stock-qty)

                    store-plan-total-qty-value
                    (sp.cmn/multiply-fields
                      variation-cost-price
                      store-plan-total-qty)

                    overview-row
                    (->
                      row
                      (assoc
                        :store-plan/stores-ranged-count (count rows)
                        :store-plan/total-store-count store-count
                        :store-plan/mdq
                        (sp.cmn/row-average :store-plan/mdq store-count rows)
                        :store-plan/in-store-stock-qty in-store-stock-qty
                        :store-plan/in-store-stock-qty-value in-store-stock-qty-value
                        ;;The buffer amount in warehouse
                        :store-plan/total-qty store-plan-total-qty
                        :store-plan/total-qty-value store-plan-total-qty-value
                        :store-plan/display-qty
                        (sp.cmn/sum-rows :store-plan/display-qty rows)
                        ;;TODO: THis is currently an avg of an avg. Might be better to sum total then do the avg
                        :variation/cost-price variation-cost-price
                        ;;TODO: Sum Income?
                        :stock/on-hand (sp.cmn/sum-rows :stock/on-hand rows)
                        :stock/transit-ibt (sp.cmn/sum-rows :stock/transit-ibt rows)
                        :stock/store-ibt (sp.cmn/sum-rows :stock/store-ibt rows)
                        :store/on-hand-history-avg
                        (sp.cmn/row-average :store/on-hand-history-avg store-count rows)
                        ;;Skipping free stock, as it shouldn't differ...
                        ;;Skipping ringfenced qty, as it shouldn't differ...
                        ;;Skipping on hand, as it shouldn't differ...
                        ;;Skipping future order, as it shouldn't differ...
                        ;;Skipping supplier on hand, as it shouldn't differ...
                        :variation/non-picking-stock (sp.cmn/sum-rows :variation/non-picking-stock rows)
                        :store/sales (sp.cmn/sum-rows :store/sales rows)
                        :stock/qty-on-hand (sp.cmn/sum-rows :stock/qty-on-hand rows)
                        :store/stock-turn
                        (sp.cmn/row-average :store/stock-turn store-count rows)
                        ;;TODO: THis is currently an avg of an avg. Might be better to sum total then do the avg
                        :store/stock-turn-avg
                        (sp.cmn/row-average :store/stock-turn-avg store-count rows)
                        ;;Skipping needed at hq, as it shouldn't differ...
                        :store-plan/ids store-plan-ids
                        :store-plan/stores (yuc/index-by :store/id rows))
                      (dissoc :store-plan/id))]
                (conj acc overview-row)))
            []))

        brands-idx
        (->>
          rows
          (reduce
            (fn [acc plan-item]
              (let [brand
                    (->
                      plan-item
                      (select-keys [:brand/root-id :brand/root-name]))
                    rood-id-exists? (get acc (:brand/root-id brand))]

                (cond
                  rood-id-exists?
                  acc

                  :else
                  (assoc acc
                    (:brand/root-id brand)
                    {:brand/id (:brand/root-id brand)
                     :brand/name (:brand/root-name brand)
                     :ent/display-name (:brand/root-name brand)}))))
            {}))

        all-brands
        (->>
          brands-idx
          (vals)
          (map
            #(assoc %
              :brand/selected? (contains? (set brandids) (:brand/id %))
              :brand/name (get-in brands [(:brand/id %) :brandrootname])
              :ent/display-name (get-in brands [(:brand/id %) :brandrootname]))))]

    (swap! action-atom assoc
      :store-plans/overview (yuc/index-by :variation/id item-rows)
      :suppliers suppliers
      :categories categories
      :brands brands
      :filters
      {:stores-idx (yuc/index-by :store-plan/id (:stores filters))
       :brands-idx (yuc/index-by :brand/id all-brands)
       :category (:category filters)
       :days (:days filters)})

    (datatables/reset-data app-atom (overview-grid-columns app-atom) (overview-table-fns app-atom))))

(defn get-save-rows [app-atom]
  (let [{:keys [row-id table-name]} (overview-grid-columns app-atom)
        table-atom (datatables/table-cursor app-atom table-name)
        table-cfg (:config @table-atom)
        data-src (:data-source table-cfg)]

    (seq
      (remove nil?
        (mapcat
          (fn [{:store-plan/keys [stores]}]
            (map
              (fn [[_ {:override/keys [in-store-stock-qty total-qty mdq] :as row}]]
                (when (or in-store-stock-qty total-qty mdq)
                  {:store-plan/id (get row :store-plan/id)
                   :variation/id (get row :variation/id)
                   :store-plan/in-store-stock-qty (or in-store-stock-qty (:store-plan/in-store-stock-qty row))
                   :store-plan/total-qty (or total-qty (:store-plan/total-qty row))
                   :store-plan/mdq (or mdq (:store-plan/mdq row))}))
              stores))
          (vals (get-in @app-atom (:cursor data-src))))))))

(defmethod grid/action :admin.store-plans/save-all-changes [app-atom _]
  (let [rows (get-save-rows app-atom)]
    #?(:cljs (.scrollTo js/window 0 0))
    (grid/close-modal app-atom)
    (toaster/open-toast app-atom :processing "Saving" {})
    (comms/send :admin.store-plans/save {:data rows})))

(rum/defc modal-save-body < rum/reactive [app-atom]
  (let [rows (get-save-rows app-atom)]
    [(headings/heading "Save changes"
       {:type :h2 :size :default})

     (if rows
       [:p "Are you sure you are happy with all the changes?"]
       [:p "No changes made yet"])]))

(rum/defc modal-save-footer [app-atom config-atom]
  (let [rows (get-save-rows app-atom)]
    [[:div
      {:class (yuc/bem :flex-grid-group [:flush])}
      [:div
       {:class (yuc/bem :flex-grid-block [:t-order-02 :t-1-2 :flush])}
       (buttons/button-web "Yes, apply changes"
         {:type :button
          :on-click #(grid/dispatch-action app-atom :admin.store-plans/save-all-changes {})
          :style :primary
          :size :large
          :disabled (empty? rows)
          :full true
          :persistent true
          :flat-style :flat})]

      [:div
       {:class (yuc/bem :flex-grid-block [:t-order-01 :t-1-2 :flush])}
       (buttons/button-web "Cancel"
         {:type :button
          :on-click #(grid/close-modal app-atom)
          :style :secondary-noborder
          :size :large
          :full true
          :persistent true
          :flat-style :flat})]]]))

(defmethod grid/modal-config :admin.store-plans/save-modal [app-atom config _]
  {:body modal-save-body
   :footer modal-save-footer
   :modal-type :variable})

(defmethod comms/receive :admin.store-plans/save [app-atom submission-response p]
  (toaster/open-toast app-atom :success "Changes applied" {:closetime 2000})
  (let [rows (:rows submission-response)
        table-atom (datatables/table-cursor app-atom :admin.store-plans/overview.datatable)
        table-cfg (:config @table-atom)
        data-src (:data-source table-cfg)
        data-atom (rum/cursor-in app-atom (:cursor data-src))]

    (swap! data-atom
      (fn [existing-data]
        (reduce
          (fn [acc row]
            (->
              acc
              (update-in [(:variation/id row) :store-plan/stores (:store-id row)]
                merge
                row)
              (dissoc
                :override/mdq :override/in-store-stock-qty :override/total-qty
                :override-type/mdq :override-type/in-store-stock-qty :override-type/total-qty)))
          existing-data
          rows)))))
